<template>
    <div class="home">
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <UserData msg="UserData" isFooter="true"/>
    <Footer msg="Footer"/>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import UserData from "@/components/UserData.vue"
import Footer from '@/components/Footer.vue'
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";

export default {
  name: "orders",
  components: {
    SettingsHeader,
    Header,
    UserData,
    Footer
    
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>